module.exports = __webpack_public_path__ + "img/alert.420bd1d.svg";